export default __webpack_public_path__ + "static/media/logo-text.bd947d7b.png";